<script setup lang="ts">
/**
 * Thin wrapper around `@gitlab/svgs`' individual icon assets. Dependency-free
 * and Vue-3-safe (unlike `@gitlab/ui`, see work_items/refactor/R014.md).
 */
import { computed } from 'vue';
import eyeSvg from '@gitlab/svgs/dist/sprite_icons/eye.svg?raw';
import eyeSlashSvg from '@gitlab/svgs/dist/sprite_icons/eye-slash.svg?raw';
import chevronDownSvg from '@gitlab/svgs/dist/sprite_icons/chevron-down.svg?raw';
import checkSvg from '@gitlab/svgs/dist/sprite_icons/check.svg?raw';

const icons = {
  eye: eyeSvg,
  'eye-slash': eyeSlashSvg,
  'chevron-down': chevronDownSvg,
  check: checkSvg,
};

const props = defineProps<{ name: keyof typeof icons }>();
const markup = computed(() => icons[props.name]);
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -- static markup from @gitlab/svgs, not user input -->
  <span class="cwc-icon" aria-hidden="true" v-html="markup" />
</template>

<style scoped>
.cwc-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--gl-spacing-4);
  height: var(--gl-spacing-4);
  flex-shrink: 0;
}

.cwc-icon :deep(svg) {
  width: 100%;
  height: 100%;
  fill: currentColor;
}
</style>
